<div class="form-group-array" [formGroup]="form">
    <div class="form-array form-array-{{ name }}" [formArrayName]="name">
        <div class="mb-2 array-label">
            <lib-input-label [field]="array" [name]="name"></lib-input-label>
        </div>
        @for (row of array.controls; track row; let i = $index, first = $first, last = $last) {
        <div class="d-inline-flex array-body-wrapper" style="width: 100%">
            <div [formGroupName]="i" class="flex-grow-1">
                <lib-form-inputs [filter]="false" [controls]="row.controls" [form]="form"></lib-form-inputs>
            </div>

            <div class="d-inline-flex">
                <p-button
                    class="mx-2"
                    (click)="removeRow(i)"
                    [disabled]="array.controls.length === 1"
                    [severity]="array.btnRemoveStyleClass"
                    icon="pi pi-minus"
                >
                </p-button>
                <p-button
                    (click)="addRow()"
                    [disabled]="!$last || (!!array.maxLength && array.maxLength === array.controls.length)"
                    [severity]="array.btnAddStyleClass"
                    icon="pi pi-plus"
                >
                </p-button>
            </div>
        </div>
        } @empty {
        <p-button label></p-button>
        }
        <lib-validation-array-messages [array]="array"></lib-validation-array-messages>
    </div>
</div>
